import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=1694b14c&scoped=true&"
import script from "./InfoBox.vue?vue&type=script&lang=js&"
export * from "./InfoBox.vue?vue&type=script&lang=js&"
import style0 from "./InfoBox.vue?vue&type=style&index=0&id=1694b14c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1694b14c",
  null
  
)

export default component.exports